import { render, staticRenderFns } from "./CTag.vue?vue&type=template&id=19dd56b0"
import script from "./CTag.vue?vue&type=script&lang=js"
export * from "./CTag.vue?vue&type=script&lang=js"
import style0 from "./CTag.vue?vue&type=style&index=0&id=19dd56b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports